import isNilOrEmpty from './isNilOrEmpty';

export default <T>(value: T) => !isNilOrEmpty(value)
